export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9207.21b5f70b.jpg";